import React from "react";

export const PlansIcon = (props) => {
  return (
    <svg
      width={20}
      height={18}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 10H6V18H0V10ZM7 0H13V18H7V0ZM14 5H20V18H14V5Z"
        fill="#B1B1B1"
      />
    </svg>
  );
};
